export default __webpack_public_path__ + "static/FarmaciasCarol-3d8119cd1e519dad858063cc6b5389cf.png";